import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { StepperQueries } from '../../../../core/store/stepper/stepper.queries';
import { EntityQueries } from '../../../../core/store/entity/entity.queries';
import { OnboardingQueries } from '../../../../core/store/onboarding/onboarding.queries';
import { HttpService } from '../../../../core/services/http/http.service';
import { ConfigQueries } from '../../../../core/store/config/config.queries';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BasePageComponent } from '../../../../core/components/component-base-page/base-page.component';
import { Entity } from '../../../../core/models/entity.model';
import { Country } from '../../../../core/models/country.interface';
import { ENTITY_TYPE } from '../../../../core/constants/enum.const';

@Component({
	selector: 'bcb-personal-details',
	templateUrl: './personal-details.component.html',
	styleUrls: ['./personal-details.component.scss'],
})
export class IndividualPersonalDetailsComponent extends BasePageComponent {
	constructor(
		configQueries: ConfigQueries,
		entityQueries: EntityQueries,
		http: HttpService,
		onboardingQueries: OnboardingQueries,
		stepperQueries: StepperQueries,
		_snackBar: MatSnackBar
	) {
		super(
			configQueries,
			entityQueries,
			http,
			onboardingQueries,
			stepperQueries,
			_snackBar
		);
	}

	initialStepAnswers(): Record<string, any> {
		return this.entityUtils.mapEntityToQuestions(this.entity);
	}

	onStepComplete(): Observable<any> {
		return this.http.individualUpdateProfile({
			...this.generatePayload(),
			entity_id: this.entity.id,
		});
	}

	private generatePayload(): Record<string, any> {
		const rawValues = this.formGroup.getRawValue();
		const entity: Entity = this.entityUtils.mapQuestionsToEntity(
			rawValues,
			ENTITY_TYPE.individual
		);

		// The question accepts several nationalities, of which this endpoint takes one. The server
		// reads the whole list off the stored answer, so the rest are not lost by sending the first.
		const answer = rawValues[this.entityUtils.questionKeys.nationality];
		const nationalities: Array<Country> = Array.isArray(answer)
			? answer
			: [answer].filter(Boolean);

		return {
			gender: entity.profile?.gender,
			first_name: entity?.first_name,
			last_name: entity?.last_name,
			email: entity?.email,
			mobile: entity?.mobile,
			dob: entity.profile?.dob,
			nationality: nationalities[0]?.code,
		};
	}
}
